import React, { useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import HandleHttpErrors from "../../HandleHttpErrors";
import useAxiosPrivateUploadFile from "../../../hooks/useAxiosPrivateUploadFile";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter, mekhraz, docOptions }) {
  let formdataFile = new FormData();
  const [newDoc, setNewDoc] = useState({
    file_url: "",
    doc_type: "",
    mekhraz: mekhraz.id,
  });
  const axiosPrivate = useAxiosPrivateUploadFile();
  const [isUplading, setIsUplading] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewDoc((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {
    e.preventDefault();
    let ext = e.target.files[0].name.split(".").pop();
    let size = e.target.files[0].size;

    if (size < 5000001) {
      formdataFile.append("file", e.target.files[0], "mdocument." + ext);
      setNewDoc((prevState) => ({
        ...prevState,
        ["file_url"]: formdataFile.get("file"),
      }));
    } else {
      alert("לא ניתן להעלות קובץ גדול מ 5MB");
    }
    setIsUplading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("mekhraz", mekhraz.id);
    formData.append("doc_type", newDoc.doc_type);
    formData.append("file_url", newDoc.file_url);

    let isMounted = true;
    const controller = new AbortController();
    const addData = async () => {
      setIsUplading(true);
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/mekhrazdocument/",
          formData,
          {
            signal: controller.signal,
          }
        );
        setNewDoc({
          file_url: "",
          doc_type: "",
          mekhraz: mekhraz.id,
        });
        alert("המסמך נוסף בהצלחה");
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else:", err);
        }
      }
      setIsUplading(false);
    };
    addData();

    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              מסמכי המכרז: {mekhraz.mkh_num} {mekhraz.title}
            </h3>
          </div>
          <div className="card-body ">
            <form onSubmit={handleSubmit} className="mbsc-form-group ">
              <Row>
                <Col>
                  <div className="form-group" style={{ textAlign: "right" }}>
                    <label htmlFor="doc_type">בחר סוג מסמך</label>
                    <select
                      name="doc_type"
                      onChange={handleChange}
                      value={newDoc.doc_type}
                      required
                    >
                      <option key="0" value="" defaultValue="0">
                        בחר סוג מסמך
                      </option>
                      {docOptions?.map((a) => (
                        <option key={a[0]} value={a[1]}>
                          {a[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <br></br>
                </Col>
                <Col>
                  <div className="form-group" style={{ textAlign: "right" }}>
                    <label htmlFor="file_url">בחר מסמך</label> <br />
                    <input
                      onClick={() => {
                        setIsUplading(true);
                      }}
                      required
                      type="file"
                      name="file_url"
                      accept="image/jpeg,image/png,image/gif,application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/x-zip-compressed"
                      onChange={(e) => {
                        handleFileChange(e);
                      }}
                    />
                  </div>
                </Col>
              </Row>
              {isUplading ? (
                <>
                  {" "}
                  <Spinner animation="border" variant="danger" visible />
                  <label>המתן עד סיום הפעולה.</label>
                </>
              ) : null}
              <br />
              <button type="submit" className="btn btn-primary">
                הוסף
              </button>
            </form>
          </div>
        </div>
      </center>
    </div>
  );
}
